import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiAccountsIdService(id: string) {
  return fetch(`accounts/${id}`, {
    method: 'GET',
    ms: 'USERS',
    auth: true,
  });
}
